export default {
  scenes: {
    surpriseEncounter: {
      beats: {
        runningIntoDaniel: {
          events: [
            {
              type: 'showLocation',
              locationId: 'gardenTerrace'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showNarration',
              text: 'Later that evening, after ensuring the wedding day runs smoothly, Isabelle steps out for air, only to unexpectedly cross paths with Daniel outside the venue.'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'We keep running into each other.',
              choices: [
                {
                  text: 'Acknowledge the Meeting as Fate',
                  next: {
                    scene: 'surpriseEncounter',
                    beat: 'acknowledgeFate'
                  }
                },
                {
                  text: 'Leave Quickly',
                  next: {
                    scene: 'surpriseEncounter',
                    beat: 'leaveQuickly'
                  }
                }
              ]
            }
          ]
        },
        acknowledgeFate: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'We keep running into each other.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'happy',
              text: 'Maybe the universe is trying to say something.'
            }
          ],
          next: {
            scene: 'surpriseEncounter',
            beat: 'confessionWithoutWords'
          }
        },
        leaveQuickly: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'I should get back inside.'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Right. Of course.'
            }
          ],
          next: {
            scene: 'surpriseEncounter',
            beat: 'confessionWithoutWords'
          }
        },
        confessionWithoutWords: {
          events: [
            {
              type: 'showNarration',
              text: 'For a long moment, neither says anything, but the air is heavy with unspoken emotions.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'thinking',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'thinking',
              text: 'Why does it feel like the world has stopped?'
            },
            {
              type: 'hideCharacter',
              characterId: 'isabelle',
              position: 'center'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I should be inside, celebrating.'
            }
          ],
          next: {
            scene: 'silentGoodbye',
            beat: 'decisionPoint'
          }
        }
      }
    },
    silentGoodbye: {
      beats: {
        decisionPoint: {
          events: [
            {
              type: 'showNarration',
              text: 'Daniel takes a deep breath, as if deciding something important.'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'I should be inside, celebrating.',
              choices: [
                {
                  text: 'He Walks Away First',
                  next: {
                    scene: 'silentGoodbye',
                    beat: 'heWalksAway'
                  }
                },
                {
                  text: 'He Hesitates, Waiting for Isabelle\'s Response',
                  next: {
                    scene: 'silentGoodbye',
                    beat: 'heHesitates'
                  }
                }
              ]
            }
          ]
        },
        heWalksAway: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'sad',
              position: 'right'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'sad',
              text: 'I shouldn\'t be here. Goodbye, Isabelle.'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Goodbye, Daniel.'
            }
          ],
          next: {
            scene: 'silentGoodbye',
            beat: 'isabellesRegret'
          }
        },
        heHesitates: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'daniel',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Daniel…'
            },
            {
              type: 'showDialog',
              speaker: 'daniel',
              variation: 'neutral',
              text: 'Say it, and I\'ll stay.'
            }
          ],
          next: {
            scene: 'silentGoodbye',
            beat: 'isabellesRegret'
          }
        },
        isabellesRegret: {
          events: [
            {
              type: 'showNarration',
              text: 'As Daniel disappears into the night, Isabelle feels an ache she can\'t explain.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'This is for the best… right?'
            }
          ],
          next: {
            scene: 'weddingNears',
            beat: 'helpingTheBride'
          }
        }
      }
    },
    weddingNears: {
      beats: {
        helpingTheBride: {
          events: [
            {
              type: 'showLocation',
              locationId: 'bridalSuite'
            },
            {
              type: 'showNarration',
              text: 'The next morning, Isabelle assists Emily in getting ready. The bride is glowing with happiness, oblivious to the storm brewing within Isabelle.'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'I\'m so excited for today!',
              choices: [
                {
                  text: 'Help Emily Write Her Vows',
                  next: {
                    scene: 'weddingNears',
                    beat: 'helpWithVows'
                  }
                },
                {
                  text: 'Focus on Logistics',
                  next: {
                    scene: 'weddingNears',
                    beat: 'focusOnLogistics'
                  }
                }
              ]
            }
          ]
        },
        helpWithVows: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'Let\'s make sure your vows are perfect.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'Daniel means everything to me. I want the words to reflect that.'
            }
          ],
          next: {
            scene: 'weddingNears',
            beat: 'hiddenPain'
          }
        },
        focusOnLogistics: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'emily',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'neutral',
              text: 'The ceremony will begin in exactly one hour. Everything is ready.'
            },
            {
              type: 'showDialog',
              speaker: 'emily',
              variation: 'happy',
              text: 'You\'re always so composed. I admire that.'
            }
          ],
          next: {
            scene: 'weddingNears',
            beat: 'hiddenPain'
          }
        },
        hiddenPain: {
          events: [
            {
              type: 'showNarration',
              text: 'As Emily happily prepares to walk down the aisle, Isabelle feels an unbearable weight pressing on her heart.'
            },
            {
              type: 'showCharacter',
              characterId: 'isabelle',
              variation: 'sad',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'isabelle',
              variation: 'sad',
              text: 'This is how it should be. I was never meant to be part of their story.'
            }
          ],
          goToChapter: {
            chapter: 'chapter4'
          }
        }
      }
    }
  }
}
